import script from "./OrderHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHeader.vue?vue&type=script&setup=true&lang=js"

import "./OrderHeader.vue?vue&type=style&index=0&id=15958294&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15958294"]])

export default __exports__